<template>
    <b-modal hide-footer id="downloadModal" size="xl" title="Download File">
        <div style="text-align: center;">
            <div v-if="url == null">
                <b-overlay :show="!hasUrl">
                    <h2>Loading</h2>
                </b-overlay>
            </div>
            <div v-else>
                <!-- <h4>This link will expire in 5 minutes.</h4> -->
                <img v-if="isImage" style="width: 100%; height: 100%;" :src="url" alt="">
                <div v-else>
                    <b-alert :show="url == null">Loading Link</b-alert>
                    <iframe style="width: 100%; height: 75vh;" v-if="url != null" :src="url" frameborder="0"></iframe>
                </div>
                <b-button class="mt-2" @click="openLink()" variant="outline-primary">Open In New Tab</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    data:() => ({
        url: null,
    }),
    props:{
        isImage:{
            default: false,
        }
    },
    computed:{
        hasUrl(){
            if(this.url == null){
                return false;
            }
            else{
                return true;
            }
        }
    },
    methods:{
        openLink(){
            window.open(this.url, "_blank");
        },
        setUrl(url){
            this.url = url;
        }
    },
    mounted(){
        this.$eventHub.$on('setDownloadUrl', this.setUrl);
    },
    beforeDestroy(){
        this.$eventHub.$off('setDownloadUrl');
    }
}
</script>

<style>
.modal-body{
    height: 90%;
}
</style>